module.exports = __webpack_public_path__ + "static/media/5-AirHeatExchanger - No cool - No heat.e1caa8e0.png";